import React, {useState, useEffect} from 'react';
import Static from '../../components/Static';
import acqua from '../../assets/lingotti/0005 - Still life Care is gold-Modifica.webp';
import oroP from '../../assets/lingotti/0020-Still-life-Care-is-gold-Modifica-2-Modifica-2.webp';
import headerImage from "../../assets/staticSection/azienda_sede.webp";
import image1 from '../../assets/codiceEtico/pexels-julien-riedel-907961520-20319546.webp'
import FullMinimalSection from '../../components/FullMinimalSection';
import codiceEtico from '../../assets/pdf/codice-etico.pdf'
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp'
import MinimalSection from '../../components/MinimalSection';
import divisionePrime from '../../assets/divisionePrime/1.jpg';
import divisionePrivate from '../../assets/divisionePrime/4.jpg';
import NavbarNew from '../../components/NavbarNew';
import AOS from "aos";
import "aos/dist/aos.css";



function Azienda() {

  const [width, setWidth] = useState(window.innerWidth);
  var ogImage = `https://www.careisgold.it${headerImage}`;

  // togliere aos transition per mini-screen
  function initAOS() {
    AOS.init({
      disable: window.innerWidth <= 320 && window.innerHeight <= 256
    });
  }
  
  initAOS();
  
  window.addEventListener("resize", () => {
    AOS.refreshHard();
  });
    
  
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  return (
    <div>
      <Helmet>
        <title>Careisgold: Leader nel mercato del risparmio in Oro</title>
        <meta name="description" content="Scopri Careisgold, azienda leader in Italia nel mercato del risparmio in oro. Offriamo soluzioni sicure e innovative per privati e aziende con trasparenza e professionalità." />
        <meta name="keywords" content="Careisgold, investimenti oro, azienda oro Italia, lingotti oro, sicurezza investimenti, trasparenza finanziaria" />
        <meta property="og:title" content="Careisgold: Leader nel mercato del risparmio in Oro" />
        <meta property="og:description" content="Scopri Careisgold, azienda leader in Italia nel mercato del risparmio in oro. Offriamo soluzioni sicure e innovative per privati e aziende con trasparenza e professionalità." />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content="https://www.careisgold.it/azienda/" />
        <meta property="og:type" content="page" />
        <link rel="canonical" href="https://www.careisgold.it/azienda/" />
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Careisgold SpA",
          "url": "https://www.careisgold.it/azienda/",
          "logo": "https://www.careisgold.it${logo}",
          "description": "Scopri Careisgold, azienda leader in Italia nel mercato del risparmio in oro. Offriamo soluzioni sicure e innovative per privati e aziende con trasparenza e professionalità.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Via Monte Baldo 14/D",
            "addressLocality": "Villafranca di Verona",
            "addressRegion": "Veneto",
            "postalCode": "37069",
            "addressCountry": "IT"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+39 045 8213155",
            "contactType": "Customer Service"
          },
          "sameAs": [
            "https://www.facebook.com/careisgoldspa",
            "https://www.instagram.com/careisgoldspa",
            "https://www.linkedin.com/company/careisgold-spa"
          ]
        }
      `}
        </script>
      </Helmet>

      <Static 
        headerImage={headerImage}
        logoTransp=''
        title='Una realtà costruita sulla cura delle persone'
        description='Il nostro motto è: l’Oro accessibile a tutti, prima di tutti. Grazie a Careisgold, infatti, chiunque può accedere al Bene Rifugio per eccellenza con semplicità e sicurezza.'
        href='/perche-scegliere-careisgold/'
        logoPosition='left-[130vh] top-[30vh] w-[110vh]'
        buttonText='PERCHÉ SCEGLIERCI'
      />

      {/* PRIMO BLOCCO STAFF/STORIA */}

      <MinimalSection
        orientation='right'
        background='bg-black'
        title="La nostra storia, la nostra crescita"
        titleClass='text-4xl text-white  mini-screen:text-xl'
        description={` Careisgold è una società per azioni del Gruppo Care Holding SpA. Care Holding SpA, attiva sul mercato da
              oltre 15 anni, si dedica costantemente alla realizzazione di progetti su misura per il benessere delle persone
              e del loro futuro.`}
        descriptionClass='text-white mini-screen:text-base'
        imageUrl={acqua}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        buttonClass1='w-full '
        buttonClass2='mt-5 w-full '
        darkButton={true}
        secondButton={true}
        href='/gruppo/'
        href2='/staff/'
        firstButtonText='Storia del gruppo'
        secondButtonText='il nostro team'
        headingIdFirst="storia-gruppo-heading"
        idFirstButton="storia-gruppo-link"
        ariaLabelledbyFirst="storia-gruppo-link storia-gruppo-heading"
        headingIdSecond="nostro-team-heading"
        idSecondButton="nostro-team-link"
        ariaLabelledbySecond="nostro-team-link nostro-team-heading"
      />


      {/* SECONDO BLOCCO DIVISIONE PRIME */}
      {width > 640 ? <MinimalSection
        orientation='left'
        background='bg-neutral-50'
        title="Divisione Prime"
        titleClass='text-4xl text-black'
        description={`Un nuovo modo di fare impresa, una nuova figura indipendente
        in un mercato ricco di opportunità. Careisgold mette a disposizione del
        pubblico una rete di collaboratori adibiti alla promozione dell’Oro da
        investimento su tutto il territorio nazionale.`}
        descriptionClass='text-black'
        imageUrl={divisionePrime}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        buttonClass1='w-full '
        secondButton={false}
        buttonClass2='hidden'
        darkButton={false}
        href='https://careacademy.it/'
        firstButtonText='Scopri di più'
        headingIdFirst="divisione-prime-heading"
        idFirstButton="divisione-prime-link"
        ariaLabelledbyFirst="divisione-prime-link divisione-prime-heading"
      /> :
        <FullMinimalSection
          headerImage={divisionePrime}
          logoTransp=''
          title='Divisione Prime'
          description={`Un nuovo modo di fare impresa, una nuova figura indipendente
        in un mercato ricco di opportunità. Careisgold mette a disposizione del
        pubblico una rete di collaboratori adibiti alla promozione dell’Oro da
        investimento su tutto il territorio nazionale.`}
          logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
          buttonText='Scopri di più'
          secondButtonText='il nostro team'
          darkButton={true}
          buttonClass='w-full'
          buttonClass2='hidden'
          href='https://4changeyourbusiness.it/'
          headingIdFirst="divisione-prime-heading"
          idFirstButton="divisione-prime-link"
          ariaLabelledbyFirst="divisione-prime-link divisione-prime-heading"
        />}

      {/* TERZO BLOCCO DIVISONE PRIVATE */}

      <MinimalSection
        orientation='right'
        background='bg-black'
        title="Divisione Private"
        titleClass='text-4xl text-white mini-screen:text-xl'
        description={`La Divisione Private di Careisgold è orientata ai
        professionisti del settore, promotori finanziari, agenti, banche, e broker che hanno
        scelto di aggiungere un nuovo, fondamentale asset per i loro clienti, puntando sulla
        sicurezza e la solidità dell’Oro.`}
        descriptionClass='text-white mini-screen:text-base'
        imageUrl={divisionePrivate}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        buttonClass1='w-full '
        buttonClass2='hidden'
        darkButton={true}
        href='/divisione-private-consulenti/'
        firstButtonText='Scopri di più'
        headingIdFirst="divisione-private-heading"
        idFirstButton="divisione-private-link"
        ariaLabelledbyFirst="divisione-private-link divisione-private-heading"
      />

      {/* QUARTO BLOCCO ORO PURO IN BOUTIQUE - gioiellerie b2c (/oro-prestige/) */}
      {width > 640 ? 
      <MinimalSection
        orientation='left'
        background='bg-neutral-50'
        title="Careisgold: l'Oro Puro in Boutique"
        titleClass='text-4xl text-black'
        description={`Con Careisgold puoi accedere al mondo dell’oro puro fisico da investimento direttamente dalla tua gioielleria di fiducia. Scopri tutti i vantaggi e i negozi convenzionati.`}
        descriptionClass='text-black'
        imageUrl={oroP}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        buttonClass1='w-full '
        buttonClass2='hidden'
        darkButton={false}
        href='/oro-prestige/'
        firstButtonText='Scopri'
        headingIdFirst="oro-prestige-heading"
        idFirstButton="oro-prestige-link"
        ariaLabelledbyFirst="oro-prestige-link oro-prestige-heading"
      /> :
      <FullMinimalSection
        headerImage={oroP}
        logoTransp=''
        title="Careisgold: l'Oro Puro in Boutique"
        description={`Con Careisgold puoi accedere al mondo dell’oro puro fisico da investimento direttamente dalla tua gioielleria di fiducia. Scopri tutti i vantaggi e i negozi convenzionati.`}
        logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
        buttonText='Scopri'
        secondButton={false}
        secondButtonText='il nostro team'
        darkButton={true}
        download={false}
        buttonClass='w-full '
        buttonClass2='hidden'
        href='/oro-prestige'
        headingIdFirst="oro-prestige-heading"
        idFirstButton="oro-prestige-link"
        ariaLabelledbyFirst="oro-prestige-link oro-prestige-heading"
      />}

      {/* QUINTO BLOCCO CODICE ETICO  */}
      <FullMinimalSection
        headerImage={image1}
        logoTransp=''
        title='Il nostro Codice Etico'
        description={`Il codice etico di Care Holding SpA mira a ridurre le incertezze, orientare i comportamenti e rispondere a
          tutti coloro che hanno rapporti, a vario titolo, con la nostra azienda. È fondamentale confermare la nostra
          visione etica e chiarire principi, valori e responsabilità comuni. Questi principi guidano le nostre relazioni
          con mercato, consumatori, comunità, dipendenti e parti interessate.`}
        href='https://careisgold.it/pdf/codice-etico.pdf'
        logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
        buttonText='Leggi di più'
        secondButton={false}
        secondButtonText='Scarica PDF'
        darkButton={true}
        buttonClass='w-full lg:w-1/2'
        buttonClass2='w-full lg:w-1/2'
        headingIdFirst="codice-etico-heading"
        idFirstButton="codice-etico-link"
        ariaLabelledbyFirst="codice-etico-link codice-etico-heading"
      />
    </div>
  )
}

export default Azienda